import { render } from "./index.vue?vue&type=template&id=25fe92a6&scoped=true&bindings={}"
import script from "./user-top-info.js?vue&type=script&lang=js"
export * from "./user-top-info.js?vue&type=script&lang=js"

import "./user-top-info.scss?vue&type=style&index=0&id=25fe92a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-25fe92a6"

export default script